import React, { useState, useEffect, useContext } from 'react';
import '../../css/level.css';
import { functionContext } from '../../App'

function Level(props) {

  let {
    level,
    allLevelStatus,
    selectedLevel
  } = props;

const { changeLevel } = useContext(functionContext);
// const levelNumber = Object.values(level)
const levelNumber = level;

// console.log("level>alllevelstatus: " + allLevelStatus.level_number);

let levelNumberNumber = parseInt(levelNumber)
// console.log(typeof levelNumberNumber)

const levelData = props.allLevelStatus?.[levelNumberNumber];
const newClass = levelData?.is_completed ? 'true' : 'false';
const ID = levelData?.level_number ?? levelNumberNumber;

// console.log(ID)

// let selectedLevelDiv = document.getElementsByClassName(`_${newClass}`);
// console.log(selectedLevel)

const isLevelSelected = ID === selectedLevel;


  return (
    <>
      <div
        onClick={() => changeLevel(levelNumberNumber)}
        id={`level_${levelNumberNumber}`}
        className={`_${newClass} ${ isLevelSelected ? "level-selected" : "" }`}>
      <p>Level {levelNumberNumber}</p>
        {/* <p>Level + {index.indexOf(index)}</p> */}
      </div>
    </>
  )
}


export default Level;
